// types
import { type ModuleType as Reference } from "./_definitions"
import { type State } from "../../types"

export const referenceSelector = (state: State): Reference => state.reference
